import { useMutation, useQueryClient } from '@tanstack/vue-query'
import { TanStackQueryIds } from '../../query/query-ids'
import type { ElementalTypeEnum } from '~~/src/types/elemental'
import { updateListItems } from '~~/src/api/elementals'

export const useUpdateListItems = () => {
  const queryClient = useQueryClient()
  return useMutation<boolean | null, Error, { id: string; itemIds: string[]; slug?: string; contentTypeId?: ElementalTypeEnum }>({
    mutationKey: ['update-list-items'],
    mutationFn: async ({ id, itemIds }) => {
      return await updateListItems(id, itemIds)
    },
    onError: (_, { id, slug }) => {
      queryClient.refetchQueries({
        queryKey: [TanStackQueryIds.LIST_ELEMENTALS, id],
        exact: false,
      })
      queryClient.refetchQueries({
        queryKey: [TanStackQueryIds.LIST_ELEMENTALS, slug],
        exact: false,
      })
    },
    onSuccess: (_, { contentTypeId, id }) => {
      if (contentTypeId) {
        queryClient.refetchQueries({
          queryKey: ['profile-list-elementals', contentTypeId],
          exact: false,
          type: 'all',
        })
      }

      queryClient.invalidateQueries({
        queryKey: [TanStackQueryIds.LIST_ELEMENTALS, id],
        exact: false,
        type: 'all',
      })

      queryClient.refetchQueries({
        queryKey: [TanStackQueryIds.LIST_ELEMENTALS, id],
        exact: false,
      })
    },
  })
}
